export default {
  experimentId: '14',
  serverUrl: 'https://magpie-cogsciprag.fly.dev//',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev//socket',
  // this will be used in prolific mode
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=CG5EQWI',
  contactEmail: 'michael.franke@gmail.com',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'debug',
  language: 'en'
};
